import { createFileRoute } from "@tanstack/react-router";
import { alternateLinkList } from "@/lib/i18n/locale";
import { AmlVietnamPage } from "./legal.aml-vietnam";

export const Route = createFileRoute("/vi/legal/aml-vietnam")({
  head: () => ({
    meta: [{ title: "AML & Tội phạm tài chính (Việt Nam) — Banana Cards" }],
    links: alternateLinkList("/legal/aml-vietnam", "vi"),
  }),
  component: AmlVietnamPage,
});